export const globalSearchConstants = {
  GET_GLOBAL_SEARCH_REQUEST: 'SEARCH/GET_GLOBAL_SEARCH_REQUEST',
  GET_GLOBAL_SEARCH_SUCCESS: 'SEARCH/GET_GLOBAL_SEARCH_SUCCESS',
  GET_GLOBAL_SEARCH_FAILURE: 'SEARCH/GET_GLOBAL_SEARCH_FAILURE',

  GET_GLOBAL_SEARCH_PAGINATION_REQUEST: 'SEARCH/GET_GLOBAL_SEARCH_PAGINATION_REQUEST',
  GET_GLOBAL_SEARCH_PAGINATION_SUCCESS: 'SEARCH/GET_GLOBAL_SEARCH_PAGINATION_SUCCESS',
  GET_GLOBAL_SEARCH_PAGINATION_FAILURE: 'SEARCH/GET_GLOBAL_SEARCH_PAGINATION_FAILURE',

  SET_FILTER_ITEM: 'SEARCH/SET_FILTER_ITEM',

  SET_SEARCH_TEXT: 'SEARCH/SET_SEARCH_TEXT',

  SET_SEARCH_SELECTED_MEMBER: 'SEARCH/SET_SEARCH_SELECTED_MEMBER'
}
